import { colors as tenantColors } from "../branding/generated/active-tokens";
import { brand as tenantBrand } from "../branding/generated/brand-manifest";
import type { ResolvedTheme } from "../utils/partnerTheme";

/**
 * Navigation labels a partner may rename (CRM Branding → App Labels), with the
 * app's own wording. Keys and defaults mirror app-backend's `UI_LABELS`
 * (service/branding/brandingValidation.ts); the wire field is `uiLabels`.
 */
export const DEFAULT_UI_LABELS = {
  navChat: "Chat",
  navShop: "Shop",
  navTrips: "Trips",
  navAccount: "Account",
  bookingTitle: "Booking",
  tabStays: "Stays",
  tabFlights: "Flights",
  tabActivities: "Activities",
  tabFlightsStays: "Flights + Stays",
};

export type UiLabelKey = keyof typeof DEFAULT_UI_LABELS;

export type PartnerBranding = {
  code: string;
  name?: string;

  logoUrl: string;
  logoDarkUrl?: string;
  iconUrl?: string;
  faviconUrl: string;

  primaryColor: string;
  secondaryColor: string;
  accentColor: string;

  /** Only the labels the partner renamed; read through `brandLabel`. */
  labels?: Partial<Record<UiLabelKey, string>>;

  /** Theme Studio (app-backend `resolvedTheme`); absent = the shipped look. */
  theme?: ResolvedTheme;
};

const tenantAsset = (publicPath: string): string => import.meta.env.BASE_URL.replace(/\/$/, "") + publicPath;

export const DEFAULT_BRANDING: PartnerBranding = {
  code: "",
  name: tenantBrand.name,
  logoUrl: tenantAsset(tenantBrand.logo.wordmark),
  faviconUrl: "",
  primaryColor: tenantColors.brand.primary,
  secondaryColor: tenantColors.brand.secondary,
  accentColor: tenantColors.brand.tertiary,
};
